import { Grid, Theme } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import DrawerEditCalendarEvent from '../../components/Calendar/DrawerEditCalendarEvent/DrawerEditCalendarEvent';
import MenuCalendarView from '../../components/Calendar/MenuCalendarView/MenuCalendarView';
import SelectCalendarUser from '../../components/Calendar/SelectCalendarUser/SelectCalendarUser';
import ShowWeekendsCheckbox from '../../components/Calendar/ShowWeekendsCheckbox/ShowWeekendsCheckbox';
import UserCalendar from '../../components/Calendar/UserCalendar/UserCalendar';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import { useClientFields } from '../../sic-lib/api/hooks/useClientFields';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
    },
    menuWrapper: {
        padding: theme.spacing(1),
    },
    flexWrapper: {
        height: 'inherit',
    },
    paper: {
        height: '100%',
        border: `1px solid ${theme.palette.divider}`,
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
    calendarWrapper: {
        height: '100%',
    },
    button: {
        padding: theme.spacing(1),
    },
}));

export default function CalendarPage() {
    const { classes } = useStyles();

    /*
        TIP: request for page dependancies which should be resolved before 
        displaying page children
     */
    const { isLoading, isError } = useClientFields();

    return (
        <React.Fragment>
            <PageMain pageTitle="Calendar" showError={isError} showLoading={isLoading}>
                <div className={classes.root}>
                    <div className={classes.menuWrapper}>
                        <Grid
                            container
                            direction="row"
                            wrap="nowrap"
                            alignItems="center"
                            spacing={2}
                            className={classes.flexWrapper}
                        >
                            <Grid item xs="auto" lg={true}>
                                <Grid container direction="row" wrap="nowrap" alignItems="center">
                                    <Grid item xs="auto">
                                        <MenuCalendarView />
                                    </Grid>
                                    <Grid item xs="auto" className={classes.marginLeft}>
                                        <ShowWeekendsCheckbox />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={true}>
                                {/*<Paper elevation={0} className={classes.paper}>*/}
                                {/*    search*/}
                                {/*</Paper>*/}
                            </Grid>
                            <Grid item xs="auto" lg={true}>
                                <Grid
                                    container
                                    direction="row"
                                    wrap="nowrap"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                >
                                    <Grid item xs="auto">
                                        <SelectCalendarUser />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.calendarWrapper}>
                        <UserCalendar />
                    </div>
                </div>
            </PageMain>
            <DrawerEditCalendarEvent />
        </React.Fragment>
    );
}
